<template>
	<nk-page commercialAccess="Sale">
		<template #badges>
			<nk-badge system="sale">
				<nk-badge-item type="system" modelValue="sale"></nk-badge-item>
			</nk-badge>
		</template>

		<div class="nk-card form-container">
			<div v-if="productFloatingsList && productFloatingsList.length === 0">
				<p class="alert alert-secondary">{{ $t('sale.product-request.m.no-product-floating-found') }}</p>
			</div>
			<div class="row">
				<div class="col-12 col-sm-6" v-for="(floating, index) in productFloatingsList" :key="floating.id">
					<nk-col-form-group :label="floating.name + ':'" :labelSizes="{ xs: 12, sm: 4 }" :dataSizes="{ xs: 12, sm: 8 }">
						<component :data="floating.productFloatingValues" :is="decideComponentType(floating)" v-model="productFloatingJson.productFloatingValues[index]" :options="getComponentOptions(floating.dataType)" :tabindex="100 + index" />
					</nk-col-form-group>
				</div>
			</div>
		</div>
	</nk-page>
</template>

<script>
	import { mapGetters } from 'vuex'
	import Input from '~/components/general/nikan-input.vue'
	import Date from '~/components/general/nikan-date.vue'
	import emptyId from '~/statics/empty-id'
	import $sc from '~/plugins/shortcut.collection.js'
	import DropDown from '~/components/general/dropdown.vue'
	import _ from 'lodash'

	export default {
		modal: {
			size: 'sm',
			stateUID: 'product-center-modify',
			helpTag: 'ProductCenterModify'
		},
		props: {
			options: { type: Object },
			data: { type: Array }
		},
		created() {

		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)
			this.productFloatingsList = this.productCentersList

			if (this.data.length)
				this.productFloatingJson.productFloatingValues = this.data

			this.productFloatingJson.productFloatingValues = this.productFloatingJson.productFloatingValues.map(floating => {
				if (floating.id === emptyId)
					floating = floating.title
				return floating
			})

			if (this.settings.productId)
				this.productFloatingJson.productId = this.settings.productId

			this.prepareWindow(this.$t('sale.product.select-center'), [this.saveButton])
		},
		data() {
			return {
				productFloatingsList: [],
				settings: {},
				productFloatingJson: {
					productFloatingValues: [],
					productId: emptyId,
				},
				saveButton: {
					title: this.$t('save'),
					isPrimary: true,
					shortcut: $sc.find('save'),
					icon: 'save',
					handle: (button, page, e) => {
						this.resolve(this.prepareData(this.productFloatingJson))
					}
				}
			}
		},
		computed: {
			...mapGetters({
				productCentersList: 'productFloatings/all',
			}),
		},
		methods: {
			prepareData(json) {
				let data = _.cloneDeep(json)
				data.productFloatingValues = data.productFloatingValues.map((floating, index) => {
					if (this.isObject(floating)) {
						floating.rowState = 'new'
						floating.productFloating = { id: floating.productFloatingId }
						delete floating.productFloatingId
					}
					else {
						let tmp
						let productFloatingId = this.productFloatingsList[index].id
						tmp = {
							title: floating,
							id: emptyId,
							productFloating: { id: productFloatingId },
							rowState: 'new',
							displayOrder: index
						}
						floating = tmp
					}
					return floating
				})
				return data
			},
			decideComponentType(floating) {
				if (floating.valueType === 'Selective')
					return DropDown

				switch (floating.dataType) {
					case 'Date':
						return Date
					default:
						return Input
				}
			},
			getComponentOptions(type) {
				switch (type) {
					case 'Numeric':
						return {
							mode: 'strnumber'
						}
					case 'Date':
						return {
							pickerEnabled: true,
						}
					default:
						return {
							mode: 'text'
						}
				}
			},
		}
	}
</script>

<style></style>